import React, { Component } from "react";
import moment from "moment";
import { withStyles } from "@mui/styles";
import MobileDetect from "mobile-detect";
import Header from "../../components/Header";
import LeftDrawerMobile from "../../components/LeftDrawerMobile";
import Hidden from "@mui/material/Hidden";
import HeaderPlain from "../../components/HeaderPlain";
import MiniLeftDrawer from "../../components/MiniLeftDrawer";
import { connect } from "react-redux";
import { userActions } from "../../actions";
import assets from "../../assets";
import { renderRoutes } from "../../utils/Routes";

import SessionExpireDialog from "../../components/SessionExpireDialog";
import classNames from "classnames";
import { pageLoadTime } from "../../utils/Helper";

const mobileDetect = new MobileDetect(window.navigator.userAgent);

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: true,
      tokenRefreshTimeInMin: 1
    };

    this.mainRef = element => {
      this.main = element;
    };

    this.mainMobileRef = element => {
      this.mainMobile = element;
    };

    this.routes = props.routes;
  }

  componentWillMount() {
    const { user } = this.props;
    const { tokenRefreshTimeInMin } = this.state;

    if (user.loggedIn && user.auth) {
      //if token expire
      const expire = moment(user.auth.expire_time);
      const diffInMinute = expire.diff(moment(), "minutes");
      if (diffInMinute < tokenRefreshTimeInMin) {
        this.props.logout();
        this.props.history.push("/");
      } else {
        this.props.getUserInfo();
      }
    } else {
      this.props.logout();
      this.props.history.push("/");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let pathname = window.location.href;

    if (pathname !== prevState.currentPath) {
      pageLoadTime(pathname);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.width !== nextProps.width) {
      this.setState({
        navDrawerOpen: nextProps.width === "500px"
      });
    }
    try {
      if (this.props.location.pathname !== nextProps.location.pathname) {
        if (this.main) {
          this.main.scrollTo(0, 0);
        }
        if (this.mainMobile) {
          this.mainMobile.scrollTo(0, 0);
        }
      }
    } catch (error) {
      console.warn("ScrollTo not working for IE/Edge, or newer unknown tech");
    }
  }

  handleMenuToggle = () => {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen
    });
  };

  render() {
    let { navDrawerOpen, tokenRefreshTimeInMin } = this.state;
    const { classes, history, user } = this.props;

    if (!user.auth) return <div />;

    const filteredRoute = this.routes.filter(
      route =>
        user.auth.scope.includes(route.access) || route.access === undefined
    );

    let images = require("../../assets").default.images;
    return (
      <div className={classes.root}>
        <SessionExpireDialog
          history={history}
          tokenRefreshTimeInMin={tokenRefreshTimeInMin}
        />
        <Hidden mdUp>
          <Header
            drawerOpen={navDrawerOpen}
            handleDrawerOpen={this.handleMenuToggle}
          />
          <div className={classes.appFrame}>
            <LeftDrawerMobile
              user={this.props.user}
              avatar={images.avatar}
              routes={this.routes}
              drawerOpen={navDrawerOpen}
              handleDrawerClose={this.handleMenuToggle}
            />
            <main ref={this.mainMobileRef} className={classes.content}>
              {renderRoutes(filteredRoute)}
            </main>
          </div>
        </Hidden>

        <Hidden smDown>
          <HeaderPlain />
          <div className={classes.appFrame}>
            <MiniLeftDrawer
              user={this.props.user}
              avatar={images.avatar}
              drawerOpen={navDrawerOpen}
              routes={this.routes}
              handleMenuToggle={this.handleMenuToggle}
            />
            <main
              ref={this.mainRef}
              className={classNames(
                classes.content,
                navDrawerOpen && classes.menuShow,
                !navDrawerOpen && classes.menuClose
              )}
            >
              {/* -- Render Child pages */}
              {renderRoutes(filteredRoute)}
            </main>
          </div>
        </Hidden>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: "100%",
    height: `calc(100% - ${theme.mixins.toolbar.minHeight}px)`,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.background.color
  },
  appFrame: {
    display: "flex",
    flex: 1,
    height: `calc(99vh - ${theme.mixins.toolbar.minHeight}px)`,
    marginTop: `64px`,
    [theme.breakpoints.down("sm")]: {
      marginTop: `${theme.mixins.toolbar.minHeight}px`
    }
  },
  content: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    overflowX: mobileDetect.mobile() === null ? "auto" : "hidden",
    WebkitOverflowScrolling: "touch",
    background: "url(" + assets.images.background + ")",
    backgroundSize: "cover",
    backgroundPosition: "100% 100%",
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  menuShow: {
    marginLeft: `${theme.miniLeftDrawer.width}px`
  },
  menuClose: {
    marginLeft: `${theme.miniLeftDrawer.widthClosed}px`
  }
});

function mapStateToProps(state, prop) {
  return {
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(userActions.logout()),
    getUserInfo: () => dispatch(userActions.getUserInfo())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Auth));
